import { applicationInsights } from "./applicationInsights"
import { trackException } from "./trackException"

import type { ErrorTag } from "src/types"

export function noticeError(
  e: unknown,
  tagKey: keyof typeof ErrorTag,
  customAttributes: Record<string, unknown> = {},
) {
  return trackException(
    e,
    tagKey,
    customAttributes,
    applicationInsights,
  )
}
